import React from 'react';
import { connect } from 'react-redux';
import { changeTabActiva, fetchDetalleNotificaciones } from '../../../actions/notificacionesActions';
import Tab from '../../General/Tab';
import NotificacionList from './NotificacionList';
import { Spinner } from 'react-bootstrap';


class Notificaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActiva: this.props.idTabActiva,
      tabs: [
        {nombre: "Cambios de stock", icono: "mdi mdi-barcode", requestId: 1},
        {nombre: "Cambios de precio", icono: "mdi mdi-currency-usd", requestId: 2},
        {nombre: "Órdenes nuevas ", icono: "sl-icon-basket-loaded", requestId: 3},
        {nombre: "Órdenes anuladas", icono: "sl-icon-ban", requestId: 4},
        {nombre: "Modificaciones de Cuotas", icono: "sl-icon-credit-card", requestId: 6}
      ]
    }
  };

  componentDidMount() {
    this.fetchDetalle();
  };

  async fetchDetalle() {
    await this.props.fetchDetalleNotificaciones({
      idSeller: this.props.idSeller,
      tipoUsuario: this.props.tipoUsuario,
      idtipoNotificacion: this.state.tabs[this.state.tabActiva].requestId
    });
  }

  cambiarTabActiva = async (index) => {
    await this.props.changeTabActiva({ idTabActiva: index });
    this.setState({tabActiva: this.props.idTabActiva});
    this.fetchDetalle();
  };

  onNotificacion = (id) => {
    let pathReturn = `/Notificaciones`;

    if (this.state.tabActiva === 2 || this.state.tabActiva === 3) {
      this.props.history.push({
        pathname: `/Ordenes/Editar/${id}`,
        state: pathReturn
      });
    } else {
      this.props.history.push({
        pathname: `/Publicaciones/Editar/${this.props.idSeller}/${id}`, 
        state: pathReturn
      });
    }
  };


  render = () => {

    let notificaciones = 
      !Array.isArray(this.props.detalleNotificaciones) ? [] : this.props.detalleNotificaciones;

    return (
      <div className="card">
        <div className='card-bpdy p-b-0'>
          <ul className="nav nav-tabs customtab" role="tablist">
            {
              this.state.tabs.map((tab, index) => {
                return (
                  <div 
                    className="col-md-6 col-lg-auto"
                    key={index} 
                    onClick={() => {this.cambiarTabActiva(index)}}
                    hidden={
                      this.props.tipoUsuario === 3 && tab.requestId === 6 ||
                      this.props.tipoUsuario === 4 && tab.requestId === 6
                    }
                  >
                    <Tab 
                      name={tab.nombre} 
                      icon={tab.icono}
                      isActive={index === this.state.tabActiva ? true : false}
                    />
                  </div>
                )
              })
            }
          </ul>
        </div>

        {
          this.props.loadingNotificaciones ?

          <div className="d-flex justify-content-center">
            <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>

          :
                // VALIDACION PARCIAL HASTA QUE FUNCIONE EL METODO
          notificaciones.length === 0 || this.props.tipoUsuario === 3 || this.props.tipoUsuario === 4 ? 

          <div className="row justify-content-center align-items-center clean-notificaciones">
            <i className="sl-icon-check p-4 col-auto"/>
            <h5 className="col-auto">NO HAY NOTIFICACIONES</h5>
          </div>
          
          :
          
          <NotificacionList
            notificaciones={notificaciones}
            onNotificacionFunction={this.onNotificacion}
            fetchDetalleFunction={this.fetchDetalle.bind(this)}
            tipoNotificacion={this.state.tabActiva}
          />
        }
      </div>
    );
  };
}


const mapStateToProps = state => ({
  idSeller: state.general.idSeller,
  tipoUsuario: state.general.tipoUsuario,
  idTabActiva: state.notificaciones.idTabActiva,
  detalleNotificaciones: state.notificaciones.detalle,
  loadingNotificaciones: state.notificaciones.loadingNotificaciones
});

export default connect(mapStateToProps, { changeTabActiva, fetchDetalleNotificaciones }) (Notificaciones);